import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Chart from '../chart'
import Table from '../table'
import DataLayout from '../data-layout'

const RevenueByDepartment = ({
  match: {
    params: { year }
  }
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetRevenue/${year}`)
      const _data = result.data.map(d => ({
        name: d.Description.trim(),
        nameClick: `/revenue/${year}/${d.LineNo.trim()}?lineDesc=${d.Description.trim()}`,
        data: d.Amount
      }))
      setData(_data.sort((a, b) => b.data - a.data))
    }

    loadData()
  }, [year])

  return (
    <DataLayout year={year}>
      <Chart data={data} />
      <Table
        data={{
          headers: [
            {
              title: 'Revenue Category',
              dataKey: 'name',
              clickThrough: 'nameClick'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data
        }}
      />
    </DataLayout>
  )
}

export default RevenueByDepartment
